import { Injectable } from '@angular/core';
import { ICustomerLoginService, IHIPLoginService, ILoginService } from '../interfaces/LoginService';
@Injectable({
    providedIn: 'root',
})
export class SharedLoginSingletonService<T extends ICustomerLoginService| IHIPLoginService> {
    public service: T;
    public isHIP: boolean = false;
    public isCustomer: boolean = false;
    public apiLink: string;

    setService(service: any): void {
        this.service = service;
    }

    setIsHIP(isHIP: boolean): void {
        this.isHIP = isHIP;
    }

    setIsCustomer(isCustomer: boolean): void {
        this.isCustomer = isCustomer;
    }

    getService(): any {
        if (!this.service) {
            throw new Error('App service has not been set');
        }
        return this.service;
    }

    getIsHIP(): boolean {
        return this.isHIP;
    }

    getIsCustomer(): boolean {
        return this.isCustomer;
    }
}
